import { render } from "./CollectionGate.vue?vue&type=template&id=6ae806a3&scoped=true"
import script from "./CollectionGate.vue?vue&type=script&lang=js"
export * from "./CollectionGate.vue?vue&type=script&lang=js"

import "./CollectionGate.vue?vue&type=style&index=0&id=6ae806a3&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae806a3"]])

export default __exports__